import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
    ContentContainer,
    SectionPage,
    Row,
    Col,
    FormHeader,
    Button,
    Heading,
    RadioButtonList,
    ErrorSummary,
    Field,
    Select,
    Icon, uiIconChevronLeft
} from '@snsw-gel/react';
import { progressStepperHelper, formHeaderLabel, formHeaderTitles } from '../../../services/progress-stepper-helper';
import { useHistory } from 'react-router-dom';
import { dataLayer } from '../../../services/gtm-dataLayer';
import { languageList } from '../../ChangeDetailFlows/ChangeMarketingDetails/languageList';
import styles from './MarketingDetails.module.scss'

const MarketingPreferencesPage = () => {
    const [error1, setError1] = useState(false);
    const [error2, setError2] = useState(false);
    const [errors, setErrors] = useState(null);
    const history = useHistory();
    const errorSummaryRef = useRef(null);

    const existingSessionDetails = sessionStorage.getItem('AdditionalDetails');
    const [additionalDetails, setAdditionalDetails] = useState(existingSessionDetails ? JSON.parse(existingSessionDetails) : {
        receiveNewsletter: null,
        notificationMethod: null,
        mainLanguage: '',
        gender: '',
        pension: '',
        aboriginal: ''
    });

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);
    }, []);

    useEffect(() => {
        if (errorSummaryRef.current) {
            errorSummaryRef.current.focus();
        }
    }, [error1, error2]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const resetValues = () => {
        additionalDetails.mainLanguage = '';
        additionalDetails.gender = '';
        additionalDetails.pension = '';
        additionalDetails.aboriginal = '';
    };

    const next = () => {
        let newErrors = [];

        switch (true) {
            case (!additionalDetails['receiveNewsletter'] || additionalDetails['receiveNewsletter'] === null) &&
                (!additionalDetails['notificationMethod'] || additionalDetails['notificationMethod'] === null):
                newErrors.push(
                    { id: 'receiveNewsletter', text: 'Select an option to continue' },
                    { id: 'notificationMethod', text: 'Select an option to continue' }
                );
                setError1(true);
                setError2(true);
                break;

            case !additionalDetails['receiveNewsletter'] || additionalDetails['receiveNewsletter'] === null:
                newErrors.push({ id: 'receiveNewsletter', text: 'Select an option to continue' });
                setError1(true);
                break;

            case !additionalDetails['notificationMethod'] || additionalDetails['notificationMethod'] === null:
                newErrors.push({ id: 'notificationMethod', text: 'Select an option to continue' });
                setError2(true);
                break;

            default:
                if (additionalDetails['receiveNewsletter'] !== null && additionalDetails['notificationMethod'] !== null) {
                    if (additionalDetails.notificationMethod === "none") {
                        const updatedDetails = {
                            ...additionalDetails,
                            mainLanguage: "",
                            gender: "",
                            pension: "",
                            aboriginal: ""
                        };

                        setAdditionalDetails(updatedDetails);
                        sessionStorage.setItem('AdditionalDetails', JSON.stringify(updatedDetails));
                    }
                    history.push('/review');
                    return;
                }
        }

        if (newErrors.length > 0) {
            setErrors(newErrors);
            scrollToTop();
        } else {
            setErrors(null);
        }
    };



    const onSelectEvent = prop => event => {
        const newAdditionalDetails = {
            ...additionalDetails,
            [prop]: event.target.value
        };

        setAdditionalDetails(newAdditionalDetails);
        sessionStorage.setItem('AdditionalDetails', JSON.stringify(newAdditionalDetails));
    }

    const onRadioChangeEvent = prop => value => {
        const newAdditionalDetails = {
            ...additionalDetails,
            [prop]: value
        };

        setAdditionalDetails(newAdditionalDetails);
        sessionStorage.setItem('AdditionalDetails', JSON.stringify(newAdditionalDetails));
    };

    return (
        <>
            <FormHeader
                title={formHeaderTitles[3]}
                label={formHeaderLabel}
                stepsList={progressStepperHelper(3)}
            />
            <ContentContainer className={styles['content-container']}>
                <SectionPage>
                    <Row>
                        <Col span={9}>

                            {(error1 || error2) &&
                                <div className={styles['error']}>
                                    <ErrorSummary
                                        ref={errorSummaryRef}
                                        errors={errors}
                                        singularTitle='Your form has an error'
                                        pluralTitle='Your form has errors' />
                                </div>}
                            <p> You can change these preferences anytime via the Seniors Card service in your MyServiceNSW Account, or by contacting us.</p>
                            <p>All fields must be completed, unless marked optional.</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={9}>
                            <Heading className={styles['newsletter-heading']} level={2}> Seniors Card email newsletter</Heading>
                            <p>Receive a monthly digital newsletter to keep you informed about offers, competitions, activities, and events. We will send it to your MyServiceNSW Account email address.</p>

                            <RadioButtonList
                                id='receiveNewsletter'
                                name='receiveNewsletter'
                                className={styles['newsletter-field']}
                                legend='Would you like to receive the Seniors Card email newsletter?'
                                vertical={true}
                                options={[
                                    { value: 'true', label: 'Yes' },
                                    { value: 'false', label: 'No' },
                                ]}
                                onChange={onRadioChangeEvent('receiveNewsletter')}
                                hasError={error1}
                                errorMessage="Select an option to continue."
                                value={additionalDetails['receiveNewsletter']}
                            />

                        </Col>
                    </Row>

                    <Row>
                        <Col span={8}>
                            <Heading
                                className={styles['notification-heading']}
                                level={2}>
                                Notifications about exclusive offers
                            </Heading>

                            <RadioButtonList
                                legend='Would you like to be informed about exclusive Seniors Card discounts and offers?'
                                id='notificationMethod'
                                name='notificationMethod'
                                className={styles['notification-field']}
                                hasError={error2}
                                errorMessage="Select an option to continue."
                                vertical={true}
                                options={[
                                    { value: 'Email only', label: ' Yes, by email only' },
                                    { value: 'Email and mail', label: 'Yes, by email and mail' },
                                    { value: 'none', label: 'No' },
                                ]}
                                onChange={onRadioChangeEvent('notificationMethod')}
                                value={additionalDetails['notificationMethod']}
                            />

                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            {additionalDetails.notificationMethod === 'none' && resetValues()}

                            {(additionalDetails.notificationMethod !== null &&
                                additionalDetails.notificationMethod !== 'none') && (<>
                                    <Heading
                                        className={styles['more-offer-heading']}
                                        level={3}> Want to receive offers more relevant to you? (Optional)
                                    </Heading>
                                    <p> If you provide more details about yourself, we can send you information more relevant to you. For example, if you answer that you receive a full pension, we can notify you about offers and events only available to full pension holders.</p>
                                    <p>This information will be shared with the Department of Communities and Justice, who manages the NSW Seniors Card Program and newsletters.</p>
                                    <p>These details are also used in a de-identified way to better understand Seniors Card members and improve the program.</p>

                                    <Field id='ex1'
                                        className={styles['language-field']}
                                        label='What is the main language spoken at home? (Optional)' errorMessage='Select a venue.'>
                                        <Select options={languageList}
                                            placeholder="Select language"
                                            onChange={onSelectEvent('mainLanguage')}
                                            value={additionalDetails.mainLanguage}
                                        />
                                    </Field>

                                    <RadioButtonList
                                        id='gender'
                                        name='Gender'
                                        legend='What is your gender?'
                                        vertical={true}
                                        options={[
                                            { value: 'Male', label: 'Male' },
                                            { value: 'Female', label: 'Female' },
                                            { value: 'Other', label: 'Other' },
                                            { value: '', label: 'Prefer not to answer' },
                                        ]}
                                        onChange={onRadioChangeEvent('gender')}
                                        value={additionalDetails['gender']}
                                        className={styles['gender-field']}
                                    />
                                    <RadioButtonList
                                        id='pension'
                                        name='Pension'
                                        legend='What is your pension status?'
                                        vertical={true}
                                        options={[
                                            { value: 'Full Pension', label: 'Full Pension' },
                                            { value: 'Part Pension', label: 'Part Pension' },
                                            { value: 'Fully Self Funded', label: "I don't receive a pension" },
                                            { value: '', label: 'Prefer not to answer' },
                                        ]}
                                        onChange={onRadioChangeEvent('pension')}
                                        value={additionalDetails['pension']}
                                        className={styles['additional-details-field']}
                                    />
                                    <RadioButtonList
                                        id='aboriginal'
                                        name='Aboriginal'
                                        legend='Are you Aboriginal and/or Torres Strait Islander?'
                                        vertical={true}
                                        options={[
                                            { value: 'true', label: 'Yes' },
                                            { value: 'false', label: 'No' },
                                            { value: '', label: 'Prefer not to answer' },
                                        ]}
                                        onChange={onRadioChangeEvent('aboriginal')}
                                        value={additionalDetails['aboriginal']}
                                        className={styles['additional-details-field']}
                                    />
                                </>)
                            }

                        </Col>
                    </Row>
                </SectionPage>
                <Row>
                    <Col span={12}>
                        <Button
                            className={styles['save']}
                            onClick={next}
                        >
                            Continue
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Button
                            iconStart={<Icon icon={uiIconChevronLeft} />}
                            className={styles['back-link']}
                            variant="link"
                            as={Link}
                            href='/eligibilityCheck'
                            aria-label='Go back'
                        >
                            Back
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

export default MarketingPreferencesPage;

